import React from 'react';

import LoginLayout from '../../pages/LoginPage';
import AuthLoginForm from './AuthLoginForm';

export default function Login() {
  return (
    <LoginLayout>
      <AuthLoginForm />
    </LoginLayout>
  );
}
